/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ArrowLeftToLine = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M3 19V5" }],
    ["path", { d: "m13 6-6 6 6 6" }],
    ["path", { d: "M7 12h14" }]
  ]
];

export { ArrowLeftToLine as default };
//# sourceMappingURL=arrow-left-to-line.js.map
